import { Grid } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';
import React, { useEffect } from 'react';
import leadsService from 'v2/services/leads/list';

import Details from './Details';
import Filter from './Filter';
import List from './List';

const useStyle = makeStyles((theme) => ({
  header: {
    display: 'flex',
  },
  title: {
    flex: '1',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: '#192542',
    '& h1': {
      fontSize: '2rem',
      lineHeight: 1,
      fontWeight: 400,
      marginBottom: '0.5rem',
    },
    '& p': {
      fontSize: '1rem',
      lineHeight: '1.3125rem',
      color: '#818b9d',
    },
  },
  reports: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(2),
  },
}));

const Leads = () => {
  const classes = useStyle({});

  useEffect(() => {
    return () => leadsService.cleanFilter();
  }, []);

  return (
    <>
      <Grid id='my-leads' container justify='space-between' alignItems='flex-start'>
        <div className={classes.title}>
          <h1>Meus Leads</h1>
          <p>Acompanhe a evolução de sua lista de Leads (e-mails) trazidos por você como produtor ou por seus afiliados.</p>
        </div>
      </Grid>
      <div className='m32' />
      <Filter />
      <Details />
      <List />
    </>
  );
};

export default Leads;
